import * as React from 'react';

import useScrollTrigger from '@mui/material/useScrollTrigger';
import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Fade from '@mui/material/Fade';

import {toRem} from "../themes/utils";

const ScrollTop: React.FC = ()=> {
    const trigger = useScrollTrigger({
        target: window ? window : undefined,
        disableHysteresis: true,
        threshold: 10,
    });

    const handleClick = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <Fade in={trigger}>
            <Box
                onClick={handleClick}
                role="presentation"
                // sx={{ position: 'fixed', bottom: { xs: toRem(112), sm: toRem( 72)}, right: "15%" }}
                sx={{ position: 'fixed', bottom: { xs: toRem(112), sm: toRem( 16)}, right: "15%" }}
            >
                <Fab size="small" aria-label="scroll back to top">
                    <KeyboardArrowUpIcon />
                </Fab>
            </Box>
        </Fade>
    );
}

export default ScrollTop;